import type { IconId } from "@drone-js/core";
import { Box, Card, GridItem, Icon, Typography, useMediaQueryContext } from "@drone-js/core";
import type { GetPropertyTypesTypeEnum } from "libs/codegen/property-onboarding";
import type { FunctionComponent } from "react";
import { usePropertyCategoryState } from "./propertyCategoryAtom";

export interface CardSelectorProps {
    type: GetPropertyTypesTypeEnum;
    title: string;
    subtitle: string;
    subtitleMobile: string;
    inactiveIcon: IconId;
    activeIcon: IconId;
    dataElementName: string;
}

export const CardSelector: FunctionComponent<CardSelectorProps> = ({
    type,
    title,
    subtitle,
    subtitleMobile,
    inactiveIcon,
    activeIcon,
    dataElementName,
}) => {
    const [propertyCategory, setPropertyCategory] = usePropertyCategoryState();
    const context = useMediaQueryContext();

    const selected = propertyCategory === type;
    const handleClick = () => setPropertyCategory(type);

    return (
        <GridItem sm={12}>
            <Card
                type="interactive"
                variant="outlined"
                p="16"
                status={selected ? "selected" : "default"}
                onClick={handleClick}
                minHeight={context.m ? "136px" : "92px"}
                data-element-name={dataElementName}
            >
                <Box display="flex" qM={{ display: "block" }}>
                    <Icon
                        id={selected ? activeIcon : inactiveIcon}
                        color={selected ? "product.primary" : "base.default"}
                        size="32"
                    />
                    <Box mt="0" ms="12" qM={{ mt: "12", ms: "0" }}>
                        <Typography
                            variant="body-default-strong"
                            textColor={selected ? "product.primary" : "base.default"}
                            mb="12"
                        >
                            {title}
                        </Typography>
                        <Box display="none" qM={{ display: "block" }}>
                            <Typography variant="body-s" textColor="base.subtle">
                                {subtitle}
                            </Typography>
                        </Box>
                        <Box display="block" qM={{ display: "none" }}>
                            <Typography variant="body-s" textColor="base.subtle">
                                {subtitleMobile}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Card>
        </GridItem>
    );
};
